import * as React from 'react';
import { Modal, Form, Icon } from 'antd';
import classnames from 'classnames/bind';
import { ModalProps } from 'antd/lib/modal';
import { FormComponentProps } from 'antd/lib/form';

import { DokButton } from 'src/components';
import { removeEmpty, createPropsGetter } from './utils';
import styles from './index.less';

const cx = classnames.bind(styles);
const initialState = {
  visible: false,
  loading: false,
};
const defaultProps = {
  modalProps: {} as ModalProps,
  minHeight: true,
};
const getProps = createPropsGetter(defaultProps);

type State = Readonly<typeof initialState>;
type DefaultProps = typeof defaultProps;
export type ModalWrapperInternalProps = Partial<DefaultProps> & {
  onOk?: (params: any) => void;
  onChange?: (...args: any) => void;
  onClose?: () => void;
  style?: React.CSSProperties;
  tag?: React.ReactNode;
  tagStyle?: React.CSSProperties;
};

type ModalWrapperProps = ModalWrapperInternalProps & FormComponentProps;

export default (Cmp: React.ComponentType<any>) => {
  class ModalWrapperInternalCmp extends React.PureComponent<ModalWrapperProps, State> {
    static defaultProps = defaultProps;

    static getDerivedStateFromProps(nextProps: ModalWrapperProps, state: State) {
      if (getProps(nextProps).modalProps.visible !== state.visible) {
        return { visible: getProps(nextProps).modalProps.visible };
      }
      return null;
    }
    readonly state = initialState;

    render() {
      const { modalProps, style, tag, tagStyle, minHeight, ...restProps } = getProps(this.props);
      const { visible, loading } = this.state;
      return (
        <Modal
          centered
          closeIcon={<Icon type="plus" className={styles['modal-close-x']} />}
          {...modalProps}
          style={style}
          visible={visible}
          confirmLoading={loading}
          onOk={modalProps.onOk || this.handleOk}
          onCancel={this.handleCancel}
          destroyOnClose={true}
          className={styles['dok-modal']}
        >
          <div
            id="modal-wrapper"
            className={cx(styles['modal-wrapper'], { [styles.min50vh]: minHeight })}
          >
            <Cmp {...restProps} />
          </div>
          {tag ? (
            <div
              className={cx([styles['modal-tag'], { [styles['modal-tag-default']]: !tagStyle }])}
              style={{ ...tagStyle }}
            >
              {tag}
            </div>
          ) : null}
        </Modal>
      );
    }

    handleCancel = () => {
      const { onClose, form } = this.props;
      this.setState({ visible: false });
      form.resetFields();
      onClose && onClose();
    };

    handleOk = () => {
      const { form, onOk } = this.props;

      form.validateFields(async (err, values) => {
        if (!err) {
          this.setState({ loading: true });
          values = removeEmpty(values);
          if (onOk) {
            await onOk(values);
          }
          form.resetFields();
          this.setState({ visible: false });
          this.setState({ loading: false });
        }
      });
    };
  }

  return Form.create({
    onValuesChange: (props: any, changedValues: any, allValues: any) => {
      changedValues = removeEmpty(changedValues);
      allValues = removeEmpty(allValues);
      props.onChange && props.onChange(allValues, changedValues);
    },
  })(ModalWrapperInternalCmp);
};
